import EmblaCarousel from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from './emblaSliderArrows';
import throttle from '../util/throttle';
import isMobile from '../util/isMobile';

export default class FeaturedProductsSlider {
  constructor(app) {
    this.app = app;
    this.sliderOptions = {};
    this.size = '';
    this.sliders = [];

    this.init = this.init.bind(this);
    this.events = this.events.bind(this);
    this.createSlider = this.createSlider.bind(this);
    this.resize = this.resize.bind(this);
    this.getSize = this.getSize.bind(this);
    this.destroy = this.destroy.bind(this);

    this.init();
  }

  init() {
    this.size = this.getSize();

    const emblaNodes = document.querySelectorAll('.js-featured-products-slider.js-embla');
    if (!emblaNodes.length) return;

    emblaNodes.forEach((emblaNode) => {
      this.createSlider(emblaNode);
    });

    this.events();
  }

  createSlider(emblaNode) {
    const viewportNodeMainCarousel = emblaNode.querySelector('.js-embla__view');
    const slides = emblaNode.querySelectorAll('.js-embla__slide');

    if ((slides.length > 1 && this.size === 'mobile') || (slides.length > 3 && this.size === 'desktop')) {
      const emblaApiMain = EmblaCarousel(viewportNodeMainCarousel, this.sliderOptions);
      this.sliders = [...this.sliders, emblaApiMain];

      const prevBtn = emblaNode.querySelector('.js-embla-button--prev');
      const nextBtn = emblaNode.querySelector('.js-embla-button--next');

      const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApiMain, prevBtn, nextBtn);

      emblaApiMain.on('destroy', removePrevNextBtnsClickHandlers);
    }
  }

  events() {
    window.addEventListener(
      'resize',
      throttle(() => this.resize(), 300)
    );
  }

  resize() {
    const newSize = this.getSize();
    if (newSize !== this.size) {
      this.destroy();
      this.init();
    }
  }

  getSize() {
    return isMobile() ? 'mobile' : 'desktop';
  }

  destroy() {
    window.removeEventListener(
      'resize',
      throttle(() => this.resize(), 300)
    );
    this.destroySliders();
    if (this.size) this.size = '';
  }

  destroySliders() {
    this.sliders.forEach((slider) => {
      if (typeof slider.destroy !== 'undefined') slider.destroy();
    });
    this.sliders = [];
  }
}



// WEBPACK FOOTER //
// ./scripts/components/featuredProductsSlider.js